
import Dexie from 'dexie';

export const db = new Dexie('KartelaDatabase');

db.version(1).stores({
    categories: '++id, name, brandId',
    products: '++id, name, brandId, *categoryIds, *kartelaIds',
    kartelas: '++id, name, code, brandId, *categoryIds'
});

// Explicitly open the database and handle errors
db.open().catch(err => {
    console.error('Dexie database failed to open:', err);
});

// Expose database to window for console debugging
if (typeof window !== 'undefined') {
    window.db = db;
}

// Helper for Turkish case-insensitive search
export const turkishSearch = (text, query) => {
    if (!query) return true;
    if (!text) return false;
    const normalize = (str) =>
        str.toLocaleLowerCase('tr-TR')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, "");

    return normalize(text).includes(normalize(query));
};

// Database Export/Import Helpers
export const exportDatabase = async () => {
    const categories = await db.categories.toArray();
    const products = await db.products.toArray();
    const kartelas = await db.kartelas.toArray();

    const data = {
        categories,
        products,
        kartelas,
        version: 1,
        exportDate: new Date().toISOString()
    };

    return JSON.stringify(data, null, 2);
};

export const importDatabase = async (jsonString) => {
    const data = JSON.parse(jsonString);

    await db.transaction('rw', db.categories, db.products, db.kartelas, async () => {
        await db.categories.clear();
        await db.products.clear();
        await db.kartelas.clear();

        await db.categories.bulkAdd(data.categories);
        await db.products.bulkAdd(data.products);
        await db.kartelas.bulkAdd(data.kartelas);
    });
};
